const appKey = "gpass"
const cdnUrl = "https://site.gcores.com"

const title = "GPASS 机核会员"
const desc = "惊喜不断、精彩不断"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  links: {
    gpassUrl: "https://www.gcores.com/gpass",
    discussUrl: "https://www.gcores.com/topics/474",
    albumsUrl: "https://www.gcores.com/privilege_albums",
    albumsAppUrl: "app://gcores.AlbumList?displayAs=gpass-album",
  },
}
